import { Steps } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

interface StepsCompleted {
  creation: boolean;
  configuration: boolean;
  apresentation: boolean;
  scheduling: boolean;
}

interface StepsWithErrors {
  creation: boolean;
  configuration: boolean;
  apresentation: boolean;
  scheduling: boolean;
}

export interface MarketplaceStepperProps {
  currentStep: number;
  onChangeStep: (value: number) => void;
  stepsCompleted: StepsCompleted;
  stepsWithErrors: StepsWithErrors;
}

const steps = [
  { title: 'Cadastro', subTitle: 'Informações básicas do item' },
  { title: 'Configuração', subTitle: 'Defina ofertas e tipo de acesso' },
  { title: 'Apresentação', subTitle: 'Apresentação e conteúdo visual' },
  { title: 'Agendamento', subTitle: 'Publicação imediata ou programada' },
];

export const MarketplaceStepper: FC<MarketplaceStepperProps> = ({
  currentStep,
  onChangeStep,
  stepsCompleted,
  stepsWithErrors,
}) => {
  const getStepStatus = (index: number) => {
    const stepKeys = [
      'creation',
      'configuration',
      'apresentation',
      'scheduling',
    ] as const;
    const stepKey = stepKeys[index];
    const isCompleted = stepsCompleted[stepKey];
    const hasErrors = stepsWithErrors[stepKey];
    const isCurrent = currentStep === index;

    if (isCurrent) return 'process';

    if (isCompleted) return 'finish';

    if (hasErrors) return 'error';

    return 'wait';
  };

  return (
    <StyledSteps
      type='navigation'
      current={currentStep}
      onChange={onChangeStep}
      labelPlacement='horizontal'
      size='default'
      items={steps.map((step, index) => ({
        title: step.title,
        subTitle: step.subTitle,
        status: getStepStatus(index) as
          | 'wait'
          | 'process'
          | 'finish'
          | 'error'
          | undefined,
      }))}
    />
  );
};

export const StyledSteps = styled(Steps)`
  margin-bottom: 40px;
  box-shadow: 0px -1px 0 0 #383838 inset;

  .ant-steps-item-title {
    display: flex;
    flex-direction: column;
    margin-left: 4px;
  }

  .ant-steps-item-title .ant-steps-item-subtitle {
    margin-top: 0;
    margin-left: 0;
    color: #8c8c8c;
  }

  .ant-steps-item-error:hover .ant-steps-item-title {
    color: #ff4d4f !important;
  }

  .ant-steps-item-error:hover .ant-steps-item-subtitle {
    color: #8c8c8c !important;
  }

  .ant-steps-item-error:hover .ant-steps-item-icon {
    border-color: #ff4d4f !important;
    background-color: #ff4d4f !important;
  }

  .ant-steps-item-error:hover .ant-steps-item-icon .ant-steps-icon {
    color: #fff !important;
  }
`;
